module.exports = __webpack_public_path__ + "static/media/acreditacoes_site_FCI.7e2f686c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/AboutView/acreditacoes_site_FCI.jpg
// module id = 843
// module chunks = 0